import React, { useEffect, useState } from "react";
import { editIcon } from "../../../Base/SVG";

export default function WalletItem({ form, updateForm, itemData, index }) {
  const [pos, setPos] = useState(itemData);
  const [edit, setEdit] = useState(false);
  const updatePos = (data) => {
    setPos((pos) => ({ ...pos, ...data }));
  };
  const onChangeInput = (input) => (e) => {
    setPos((pos) => ({ ...pos, [input]: e.target.value }));
  };

  useEffect(() => {
    let arr = [...form.wallets];
    arr[index] = pos;
    updateForm({ wallets: arr });
  }, [pos]);
  return (
    <>
      <div className="walletsItem">
        <div className="walletsItem__row">
          <div className="input__outer">
            <label htmlFor="">Your Wallet Address</label>
            <div className="input wIcon">
              <input
                type="text"
                disabled={edit ? false : true}
                value={pos.address}
                onChange={onChangeInput("address")}
              />
              <button
                className="button"
                type="button"
                onClick={() => setEdit(!edit)}
              >
                {editIcon}
              </button>
            </div>
          </div>
          <div className="check">
            <div className="check__row">
              <img src={process.env.PUBLIC_URL + pos.networkIcon} alt="coin" />
              <p className="sw">{pos.network}</p>
            </div>
            <div className="checkInput">
              <input
                type="checkbox"
                checked={pos.status}
                onChange={(e) => updatePos({ status: e.target.checked })}
              />
              <label htmlFor=""></label>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        <div className="walletsItem__row sb">
          {pos?.coins.map((item, index) => {
            return (
              <CoinItem
                pos={pos}
                updatePos={updatePos}
                itemCoinData={item}
                key={index}
                index={index}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}

const CoinItem = ({ pos, updatePos, itemCoinData, index }) => {
  const [coinPos, setCoinPos] = useState(itemCoinData);
  const updateCoinPos = (data) => {
    setCoinPos((coinPos) => ({ ...coinPos, ...data }));
  };
  useEffect(() => {
    let arr = [...pos.coins];
    arr[index] = coinPos;
    updatePos({ coins: arr });
  }, [coinPos]);
  return (
    <div className="walletsItem__coin">
      <div className="check">
        <div className="check__row">
          <img src={process.env.PUBLIC_URL + coinPos.coinIcon} alt="coin" />
          <p>{coinPos.coin}</p>
        </div>
        <div className="checkInput">
          <input
            type="checkbox"
            checked={coinPos.status}
            onChange={(e) => updateCoinPos({ status: e.target.checked })}
          />
          <label htmlFor=""></label>
        </div>
      </div>
    </div>
  );
};
